import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import AppWhoopLogo from "@/assets/appwhoop_ticket_logo.webp";
import AppWhoopOnDives from "@/assets/AppWhoop.com Ticketera Digital.webp";

// <>
// <div id="rotate-notice">Por favor, gira tu dispositivo a vertical para continuar.</div>
// </>

export default function CommingSoon() {
  return (
    <main
      id="app-content"
      className="flex flex-col items-center justify-center min-h-screen bg-aw-bgbluedark"
    >
      <div id="bck-cooming-soon" className="w-full flex flex-col items-center justify-center min-h-screen">
        <div className="flex flex-col gap-y-3 p-4 md:w-2/3 2xl:w-3/7">
          <div className="flex items-center justify-center">
            <LazyLoadImage
              alt="AppWhoop Logo"
              effect="blur"
              wrapperProps={{
                // If you need to, you can tweak the effect transition using the wrapper style.
                style: { transitionDelay: "0.3s" },
              }}
              src={AppWhoopLogo}
              className="w-4/5 sm:w-1/2 xl:w-2/5 object-contain mx-auto"
            />
          </div>
          <div className="flex flex-col text-center items-center justify-center text-white mb-8">
            <h2 className="text-3xl sm:text-5xl 2xl:text-6xl font-bold text-white mb-5">
              <span className="text-aw-green">Potencia tus ventas</span>{" "}
              <span className="text-white">con total control de tus eventos</span>
            </h2>
            <p className="font-medium text-base lg:text-xl 2xl:text-2xl leading-[1.1] mb-8">
              En <span className="text-aw-green">AppWhoop</span>, conviértete en dueño de tus eventos. Vende tus tickets en línea, 
              gestiona todo desde una sola plataforma y multiplica tus ventas gracias a 
              embajadores freelance conectados desde cualquier lugar del mundo.
            </p>
            <h2 className="text-xl sm:text-3xl 2xl:text-4xl font-bold bg-aw-green rounded-2xl py-4 px-8">
              <span className="text-aw-bluedark">Próximamente!</span>
            </h2>
          </div>
          <div className="flex text-center items-center justify-center">
            <LazyLoadImage
              alt="AppWhoop Logo"
              effect="blur"
              wrapperProps={{
                // If you need to, you can tweak the effect transition using the wrapper style.
                style: { transitionDelay: "0.3s" },
              }}
              src={AppWhoopOnDives}
              className="w-full sm:w-4/5 xl:w-4/5 object-contain mx-auto"
            />
          </div>
        </div>
      </div>
    </main>
  );
}
